/**
 * @ngdoc controller
 * @name DropdownController
 * @description
 * This component renders the Dropdown component.
 *
 * @memberof common
 */
class DropdownController {
  /**
   * Class constructor
   * @ignore
   */
  constructor() {
    /**
     * Local reference if the dropdown is open or not.
     * @type {Boolean}
     */
    this.open = false;
    /**
     * Local reference for the selected item.
     * @type {Null|Object}
     */
    this.selected = null;
    /**
     * Local reference if the dropdown is in error or not.
     * @type {Boolean}
     */
    this.error = false;
  }
  /**
   * Handle the dropdown open change.
   */
  toggleDropdown() {
    this.open = !this.open;
  }
  /**
   * Handle the keyup event.
   * @param {Object} $event the keyup event.
   */
  onKeyup($event) {
    const enterKeycode = 13;
    if ($event.keyCode === enterKeycode) {
      this.open = !this.open;
    }
  }
  /**
   * Handle when the selected item changes.
   * @param {Object} item the new selected item.
   */
  itemSelectedChange(item) {
    this.selected = item;
    this.open = false;
    this.error = false;
    this.onItemSelected({ item });
  }
  /**
   * Each time the data binding changes, update the selected item
   * and error flag accordingly.
   */
  $onChanges({ selectedItem, inError }) {
    if (this.items && this.items.length > 0 && selectedItem && selectedItem.currentValue) {
      this.selected = this.items.find((item) => item.id === selectedItem.currentValue.id);
    }

    if (inError && inError.currentValue) {
      this.error = inError.currentValue;
    }
  }
}

export default DropdownController;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/components/dropdown/dropdown.controller.js